import { v4 as uuidv4 } from 'uuid';

import { dispatchPromise, fetchResources } from './action-helpers';

const DEFAULT_AUTOMATION_PROPS = {
    id: null,
    name: ''
};

export const createAutomation = automationProps => {
    return dispatchPromise({
        type: 'AUTOMATION_CREATE_REQUESTED',
        payload: {
            automation: Object.assign({}, DEFAULT_AUTOMATION_PROPS, automationProps, {
                id: uuidv4()
            })
        }
    });
}

export const fetchAutomations = (projectId, all) => fetchResources('AUTOMATIONS_FETCH_REQUESTED', { projectId }, all);

export const fetchAutomation = automationId => {
    return dispatchPromise({
        type: 'AUTOMATION_FETCH_REQUESTED',
        payload: { automationId }
    });
}

export const updateAutomation = (automationId, automationProps, preventSave) => {
    return dispatchPromise({
        type: 'AUTOMATION_UPDATE_REQUESTED',
        preventSave,
        payload: {
            automationId,
            automationProps
        }
    });
}

export const removeAutomation = automationId => {
    return dispatchPromise({
        type: 'AUTOMATION_REMOVE_REQUESTED',
        payload: {
            automationId
        }
    });
}
